import React from 'react';
import { Grid } from '@mui/material';
import Skeleton from '@mui/material/Skeleton';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme) => ({
  item: {
    background: '#fff',
    borderRadius: 6,
    boxShadow: theme.boxShadow,
    padding: '3rem',
    flexWrap: 'nowrap',
    flexDirection: 'row',
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column'
    }
  },
  avatar: {
    flexShrink: 0,
    marginRight: '2rem',
    [theme.breakpoints.down('md')]: {
      marginBottom: '2rem'
    }
  },
  content: {
    flexGrow: 1
  },
  line: {
    marginTop: '0.8rem'
  }
}));

// Placeholder grid shown while the authors list loads, mirroring AuthorListItem so the
// real cards don't pop in over a blank area.
const AuthorListItemSkeleton = () => {
  const classes = useStyles();
  return (
    <Grid item xs={12} sm={6}>
      <Grid container className={classes.item}>
        <Grid item className={classes.avatar}>
          <Skeleton variant='circular' width='10rem' height='10rem' />
        </Grid>
        <Grid item className={classes.content}>
          <Skeleton variant='text' width='60%' height='3.2rem' />
          <Skeleton variant='text' className={classes.line} />
          <Skeleton variant='text' className={classes.line} />
          <Skeleton variant='text' width='80%' className={classes.line} />
        </Grid>
      </Grid>
    </Grid>
  );
};

const AuthorsSkeleton = () => {
  return (
    <Grid
      container
      direction='row'
      justifyContent='center'
      alignItems='flex-start'
      spacing={3}
    >
      {Array.from({ length: 6 }, (_, index) => (
        <AuthorListItemSkeleton key={index} />
      ))}
    </Grid>
  );
};

export default AuthorsSkeleton;
